function count(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`;
}

function joinList(parts: string[]): string {
  if (parts.length <= 2) return parts.join(' and ');
  return `${parts.slice(0, -1).join(', ')}, and ${parts[parts.length - 1]}`;
}

export function planContentLabel(plan: {
  tasks?: readonly unknown[] | null;
  forms?: readonly unknown[] | null;
  files?: readonly unknown[] | null;
  rosterTemplateIds?: readonly unknown[] | null;
  layers?: readonly unknown[] | null;
}): string {
  const parts = [
    count(plan.tasks?.length ?? 0, 'task', 'tasks'),
    count(plan.forms?.length ?? 0, 'form', 'forms'),
  ];
  const files = plan.files?.length ?? 0;
  const templates = plan.rosterTemplateIds?.length ?? 0;
  const layers = plan.layers?.length ?? 0;
  if (files > 0) parts.push(count(files, 'file', 'files'));
  if (templates > 0) parts.push(count(templates, 'template', 'templates'));
  if (layers > 0) parts.push(count(layers, 'layer', 'layers'));
  return parts.join(' · ');
}

export function planApplyToast(result: {
  createdCount: number;
  createdFormCount?: number;
  createdFileCount?: number;
  rosterSeatsAdded?: number;
  suggestedLayers?: readonly { name: string }[];
}): string {
  const created: string[] = [];
  if (result.createdCount > 0) {
    created.push(count(result.createdCount, 'task', 'tasks'));
  }
  const forms = result.createdFormCount ?? 0;
  if (forms > 0) created.push(count(forms, 'form', 'forms'));
  const files = result.createdFileCount ?? 0;
  if (files > 0) created.push(count(files, 'file', 'files'));
  const seats = result.rosterSeatsAdded ?? 0;
  if (seats > 0) created.push(count(seats, 'roster seat', 'roster seats'));

  const sentences = [
    created.length > 0
      ? `Created ${joinList(created)} from the plan`
      : 'Applied the plan',
  ];
  const layers = (result.suggestedLayers ?? []).map((layer) => layer.name);
  if (layers.length > 0) {
    sentences.push(`Suggested map layers: ${layers.join(', ')}`);
  }
  return sentences.join('. ');
}
